<template>
  <div class="success-failure-display-container">
    <div :class="error ? 'err-message' : ''" class="success-failure-display">
      <v-icon>{{ error ? 'sentiment_dissatisfied' : 'sentiment_satisfied_alt' }}</v-icon>
      <span class="message">{{ message }}</span>
    </div>
    <span v-if="hint">{{ hint }}
    </span>
  </div>
</template>
<script>
export default {
  props: {
    //message should be short (not more than two lines). additional information should be shown via hint
    message: {
      type: String,
      required: true
    },
    error: {
      type: Boolean,
      default: false
    },
    hint: {
      type: String,
      default: null
    }
  }
};
</script>
<style>
.success-failure-display-container {
  min-width: 768px;
}
.success-failure-display {
  background-color: #e0eaf7;
  height: 72px;
  overflow: hidden;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #0085CF;
  margin: 56px 0 40px 0;
}
.success-failure-display.err-message {
  background-color: #fde8e8;
  color: #EF5350;
}
.success-failure-display .v-icon{
  color: #0085CF !important;
  position: absolute;
  left: -40px;
  font-size: 148px;
  height: inherit;
}
.success-failure-display .message {
  padding: 0 120px;
  overflow: hidden;
  max-height: 100%;
}
.success-failure-display.err-message .v-icon {
  color: #EF5350 !important;
}
</style>
